//css import
import '../../scss/pages/home.scss';
import 'swiper/css/bundle';
//js import
import 'regenerator-runtime/runtime'
import Swiper from 'swiper/bundle';
import axios from "axios";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {initializeCollaborationsSliders } from '../sections/collaborations.js';
import { counterAnimation } from '../modules/counterAnimation.js';
gsap.registerPlugin(ScrollTrigger);


const PartnerUsTitle=document.querySelector('#partner-us-title');
const titleHolderMobile=document.querySelector('.partner-with-us__title-mobile');
const titleHolderDesktop=document.querySelector('.partner-with-us__title-desktop');


//2. Event listeners

function banner(){
    let bannerSlider = new Swiper(".banner__slider", {
        spaceBetween: 0,
        slidesPerView:1,
        effect: "fade",
        loop:true,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: ".banner__next",
            prevEl: ".banner__prev",
        },
        pagination: {
            el: ".banner__pagination",
            clickable: true,
        },
    });
}

function welcome(){
    let welcomeSlider = new Swiper(".welcome__slider", {
        spaceBetween: 0,
        slidesPerView:1,
        effect: "fade",
        loop:true,
        // autoplay: {
        //     delay: 5000,
        // },
        navigation: {
            nextEl: ".welcome__next",
            prevEl: ".welcome__prev",
        },
        pagination: {
            el: ".welcome__pagination",
            clickable: true,
        },
    });
    
    welcomeSlider.on('slideChangeTransitionEnd', function () {
        let index = welcomeSlider.activeIndex
    })
}

function business(){
    let businessSlider = new Swiper('.our-bussiness__slider', {
        speed:1000,
        spaceBetween: 16,
        slidesPerView: 1,
        centeredSlides: true,
        loop: false,
        freeMode: true,
        navigation: {
            prevEl: ".our-bussiness__prev",
            nextEl: ".our-bussiness__next",
        },
        pagination: {
            el: ".our-bussiness__pagination",
            clickable:true
        },
        breakpoints: {
            320: {
                centeredSlides: false,
                slidesPerView: 2
            },
            768:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            },
            992:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            },
            1024:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            },
            1440:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            },
            1600:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            },
            1920:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            }
        }
    });
}

const getYoutubeSubs= async()=>{
    const youtubeID="UC5Tg_aUYKBtpnGipTVqDDuQ";
    const apiKeyYT="AIzaSyBbzRRFD-5EY3__jAinUceuxP9LMEpMw6M";
    const totalSubscriberYT=document.querySelector('#totalSubscriberYT');
    const totalViewYT=document.querySelector('#totalViewYT');
    const getData= await axios.get(`https://www.googleapis.com/youtube/v3/channels?part=statistics&id=${youtubeID}&key=${apiKeyYT}`);
    const ytData=getData.data.items[0].statistics
    // totalSubscriberYT.innerHTML=new Intl.NumberFormat().format(ytData.subscriberCount);
    // totalViewYT.innerHTML=new Intl.NumberFormat().format(ytData.viewCount);

    totalSubscriberYT.innerHTML=ytData.subscriberCount;
    totalViewYT.innerHTML=ytData.viewCount;

    totalSubscriberYT.dataset.value=ytData.subscriberCount;
    totalViewYT.dataset.value=ytData.viewCount;
}

getYoutubeSubs();



function subscriber(){
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".subscribers",
            //scrub: 2,
            //end: "200%",
            //pin: true,
            //markers: true,
        }
    });
    
    tl.addLabel("cloudshow")
    .to(".subscribers__cloud-small", {duration: 1,xPercent: 15,},"cloudshow")
    .to(".subscribers__cloud-big", {duration: 1,xPercent: -15,},"cloudshow")
    .to(".subscribers__tree-right", {duration: 1,xPercent: -10,},"cloudshow")
    .to(".subscribers__tree-left", {duration: 1,xPercent: 10,},"cloudshow+=0.3")
    counterAnimation('.card-subscribers-wrapper','.card-subscribers__value')
}


window.addEventListener("load", function () {
    if (window.innerWidth <= 767) {
        titleHolderMobile.append(PartnerUsTitle)
	} else {
		titleHolderDesktop.append(PartnerUsTitle)
	}
    initializeCollaborationsSliders();
    banner();
    welcome();
    business();
    subscriber()
});

window.addEventListener("resize", function(){
    if (window.innerWidth <= 767) {
        titleHolderMobile.append(PartnerUsTitle)
	} else {
		titleHolderDesktop.append(PartnerUsTitle)
	}
});












